import React, { Component } from 'react';
import { Tab, Row, Nav, NavItem, Button, Glyphicon } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import Checkbox from '../Checkbox';
import PredictTextModal from '../DocumentViewer/PredictTextModal';
import { history } from '../../helpers';
import '../../content/css/HighlightTexts.css';
import '../../content/css/EditableTextArea.css';

export default class HighlightTextBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: this.props.activeTab,
            notes: this.props.highlight.notes,
            isSelected: this.props.highlight.isSelected,
            typingTimer: null,
            showPredictModal: false,
            language: "",
            guidanceShownOnce: false,
            guidanceTypedText: '',
            isAITyping: false
        }
    }

    componentDidMount() {
        if (this.getActiveTab() === 'guidance' && !this.state.guidanceShownOnce && this.hasAIGuidance()) {
            this.startTypingGuidance();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.getActiveTab() === 'AI_guidance' &&
            !this.state.guidanceShownOnce &&
            this.hasAIGuidance() &&
            !this.state.isAITyping &&
            this.state.guidanceTypedText.length === 0 &&
            !this.props.isMinimized &&
            this.props.visibility !== 'hidden'
        ) {
            // Guarantee typewriter starts if Guidance tab is active after initial mount or after tab switch
            this.startTypingGuidance();
        }
    }

    componentWillUnmount() {
        if (this.state.typingTimer) {
            clearInterval(this.state.typingTimer);
        }
    }

    getMainContent() {
        if (this.props.highlight === null) return "";
        return this.props.highlight.feedbackGuidance || "";
    }

    getAIGuidanceTextOnly() {
        if (!this.props.highlight || !this.props.highlight.feedbackAIGuidance)
            return "";

        return this.props.highlight.feedbackAIGuidance.trim();
    }

    getExamplesContent() {
        if (this.props.highlight === null) return "";
        return this.props.highlight.feedbackExamples;
    }

    getExplanationContent() {
        if (this.props.highlight === null) return "";
        return this.props.highlight.feedbackExplanation;
    }

    getApprovalContent() {
        if (this.props.highlight === null) return "";
        return this.props.highlight.feedbackApproval;
    }

    getAdminContent() {
        if (this.props.highlight === null) return "";

        var highlight = this.props.highlight;
        var text = `<strong>Code:</strong> ${highlight.categoryCode}<br/><strong>Text:</strong> ${highlight.text}<br/><br/>`;
        let data = highlight.dataExtractions || {};
        for (const key in data) {
            text += `<strong>${key}</strong>: ${data[key]}<br/>`;
        }
        text += `<strong>Playbook:</strong> ${highlight.originThemePackage}<br/>`;
        text += `Used model created on <strong>${highlight.modelCreated}</strong>`;

        return text;
    }

    getStyle() {
        return {
            top: this.props.top + "px"
        };
    }

    getClassName() {
        let minimized = this.props.isMinimized ? " minimize" : "";
        let selected = this.state.isSelected ? "" : " inactive";
        let visible = this.props.visibility === "hidden" ? " hidden" : "";
        let isActiveClass = this.props.highlight.isActive ? "" : " disabled";
        return `box risk-${this.props.highlight.risk}${minimized}${selected}${visible}${isActiveClass}`;
    }

    getActiveTab() {
        return this.state.activeTab || (this.hasGuidance() ? "AI_guidance" : "admin");
    }

    hasAIGuidance() {
        return this.props.highlight && this.props.highlight.feedbackAIGuidance;
    }

    hasGuidance() {
        return this.props.highlight && (this.props.highlight.feedbackGuidance || this.hasAIGuidance());
    }

    hasExamples() {
        return this.props.highlight && this.props.highlight.feedbackExamples;
    }

    hasExplanation() {
        return this.props.highlight && this.props.highlight.feedbackExplanation;
    }

    hasApproval() {
        return this.props.highlight && this.props.highlight.feedbackApproval;
    }

    hasNotes() {
        return !this.props.hideNotes;
    }

    hasBreach = () => {
        return this.props.highlight && this.props.highlight.breachData && this.props.highlight.breachData.isBreach;
    }

    handleNotesChange = e => {
        var notes = e.target.value;
        this.setState({ notes });

        var doneTypingInterval = 3000;
        clearTimeout(this.state.typingTimer);
        this.setState({ typingTimer: setTimeout(doneTyping, doneTypingInterval) });

        var self = this;
        function doneTyping() {
            self.props.onNotesChange(self.props.highlight.textSegmentId, self.props.highlight.categoryCode, notes);
        }
    }

    handleShowPredictModal = (show) => {
        this.setState({ showPredictModal: show });
    }

    handleDelete = () => {
        if (this.props.highlight === null) return;
        this.props.onDelete(this.props.highlight.id)
    }

    handleSelectChange = (value) => {
        this.setState({ isSelected: value });
        this.props.onSelectChange(this.props.highlight.textSegmentId, this.props.highlight.categoryCode, value);
    }

    handleTabSelect = (key) => {
        this.setState({ activeTab: key });

        if (key === 'guidance' && !this.state.guidanceShownOnce && this.hasAIGuidance()) {
            this.startTypingGuidance();
        }
    }

    startTypingGuidance() {
        const aiText = this.getAIGuidanceTextOnly() || '';
        let currentIndex = 0;
        const typingSpeed = 20;

        if (this.state.typingTimer) {
            clearInterval(this.state.typingTimer);
        }

        this.setState({ isAITyping: true, guidanceTypedText: '' });

        const typingTimer = setInterval(() => {
            currentIndex++;

            this.setState({
                guidanceTypedText: aiText.substring(0, currentIndex)
            });

            if (currentIndex >= aiText.length) {
                clearInterval(typingTimer);
                this.setState({
                    guidanceShownOnce: true,
                    typingTimer: null,
                    isAITyping: false
                });
            }
        }, typingSpeed);

        this.setState({ typingTimer });
    }

    render() {
        let isHiddenFromGuest = !this.props.highlight.isActive;
        let title = isHiddenFromGuest ? "This is a key clause!" : this.props.highlight.categoryName;
        let signupClicked = () => history.push("/limited-review");
        let isActiveClass = this.props.highlight.isActive ? "" : " disabled";
        let hasBreach = this.hasBreach();

        return (
            <div className={this.getClassName()} style={this.getStyle()}>
                <div className="box-header">
                    <div className={`marker risk-${this.props.highlight.risk}${isActiveClass}`}>
                        {hasBreach && <Glyphicon glyph="flash" />}
                    </div>
                    <span className="title"><strong>{title}</strong></span>
                    <span className="position">{this.props.index + 1}/{this.props.highlightsCount}</span>
                </div>
                {isHiddenFromGuest &&
                    <div>
                        To see what this clause is about you need to become a customer.
                        <br />
                        <br />
                        <Button onClick={signupClicked}>Get Full Access</Button>
                    </div>
                }
                {!isHiddenFromGuest &&
                    <React.Fragment>
                        {!this.props.isMinimized &&
                            <Tab.Container id="box-tabs" activeKey={this.getActiveTab()} onSelect={this.handleTabSelect}>
                                <Row>
                                    <div className={`tabs risk-${this.props.highlight.risk}`}>
                                        <Nav bsStyle="pills" stacked>
                                            {this.hasAIGuidance() && <NavItem eventKey="AI_guidance">What to do</NavItem>}
                                            {this.hasGuidance() && <NavItem eventKey="guidance">Playbook</NavItem>}
                                            {this.hasExamples() && <NavItem eventKey="examples">Example clause</NavItem>}
                                            {this.hasExplanation() && <NavItem eventKey="explanation">Background</NavItem>}
                                            {this.hasApproval() && <NavItem eventKey="approval">Get approval</NavItem>}
                                            {this.hasNotes() && <NavItem eventKey="notes">Your notes</NavItem>}
                                            {this.props.isAdmin && <NavItem eventKey="admin">Admin</NavItem>}
                                        </Nav>
                                    </div>
                                    <Tab.Content animation>
                                        {this.hasAIGuidance() &&
                                            <Tab.Pane eventKey="AI_guidance">
                                                <div style={{ marginTop: '10px', marginRight: '5px', backgroundColor: '#f9f9f9', border: '1px solid #ddd', borderRadius: '4px', padding: '10px' }}>
                                                    <strong>Contract AI says:</strong>
                                                    {this.state.guidanceTypedText.length === 0 ? (
                                                        <div style={{ fontStyle: 'italic', color: '#999', marginTop: '5px' }}>
                                                            <Glyphicon glyph="refresh" className="spinning" /> Contract AI is analyzing...
                                                        </div>
                                                    ) : (
                                                        <ReactMarkdown
                                                            classname="box-content"
                                                            source={this.state.guidanceTypedText.replace(/\n/g, "\n> ")}
                                                            escapeHtml={false}
                                                        />
                                                    )}
                                                </div>
                                            </Tab.Pane>
                                        }

                                        {this.hasGuidance() &&
                                            <Tab.Pane eventKey="guidance">
                                                <ReactMarkdown
                                                    classname="box-content"
                                                    source={this.getMainContent()}
                                                    escapeHtml={false}
                                                />
                                            </Tab.Pane>
                                        }

                                        {this.hasExamples() &&
                                            <Tab.Pane eventKey="examples">
                                                <ReactMarkdown classname="box-content" source={this.getExamplesContent()} escapeHtml={false} />
                                            </Tab.Pane>
                                        }

                                        {this.hasExplanation() &&
                                            <Tab.Pane eventKey="explanation">
                                                <ReactMarkdown classname="box-content" source={this.getExplanationContent()} escapeHtml={false} />
                                            </Tab.Pane>
                                        }

                                        {this.hasApproval() &&
                                            <Tab.Pane eventKey="approval">
                                                <ReactMarkdown classname="box-content" source={this.getApprovalContent()} escapeHtml={false} />
                                            </Tab.Pane>
                                        }

                                        {this.hasNotes() &&
                                            <Tab.Pane eventKey="notes">
                                                <div className="editable-markdown">
                                                    <div className="editor">
                                                        <textarea key="editor" value={this.state.notes} onChange={this.handleNotesChange} autoFocus='true' />
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                        }

                                        {this.props.isAdmin &&
                                            <React.Fragment>
                                                <Tab.Pane eventKey="admin">
                                                    <ReactMarkdown classname="box-content" source={this.getAdminContent()} escapeHtml={false} />
                                                    <Button onClick={this.handleShowPredictModal}>Check concepts</Button>
                                                    <Button onClick={this.handleDelete}>Delete</Button>
                                                </Tab.Pane>
                                                <PredictTextModal
                                                    show={this.state.showPredictModal}
                                                    text={this.props.highlight.text}
                                                    language={this.state.language}
                                                    onClose={() => this.handleShowPredictModal(false)}
                                                />
                                            </React.Fragment>
                                        }
                                    </Tab.Content>
                                </Row>
                            </Tab.Container>
                        }
                        {!this.props.hideActionRequiredButton &&
                            <div className="export-select">
                                <span>Action required - include in export?</span>
                                <Checkbox value={this.state.isSelected} onChange={this.handleSelectChange} />
                            </div>
                        }
                    </React.Fragment>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Highlight/HighlightTextBox.js